import React, { useEffect, useState } from 'react';
import RecipeItem from '../components/RecipeItem';

function Reseptit() {
    const [recipes, setRecipes] = useState([]);
    const [visibleRecipes, setVisibleRecipes] = useState([]);
    const [favoriteRecipes, setFavoriteRecipes] = useState([]);
    const [shoppingList, setShoppingList] = useState([]);
    const [showShoppingList, setShowShoppingList] = useState(false);

    useEffect(() => {
        const storedFavorites = JSON.parse(localStorage.getItem('favoriteRecipes')) || [];
        setFavoriteRecipes(storedFavorites);
    }, []);

    useEffect(() => {
        fetch('/reseptit.json')
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                setRecipes(data);
                setVisibleRecipes(data);
            })
            .catch(error => console.error('Error fetching JSON data:', error));
    }, []);

    const toggleFavorite = (recipeID) => {
        let updatedFavorites;
        if (favoriteRecipes.includes(recipeID)) {
            updatedFavorites = favoriteRecipes.filter(id => id !== recipeID);
        } else {
            updatedFavorites = [...favoriteRecipes, recipeID];
        }
        setFavoriteRecipes(updatedFavorites);
        localStorage.setItem('favoriteRecipes', JSON.stringify(updatedFavorites));
    };

    const clearFavorites = () => {
        setFavoriteRecipes([]);
        localStorage.setItem('favoriteRecipes', JSON.stringify([]));
        setShoppingList([]);
    };

    const generateShoppingList = () => {
        let list = [];
        favoriteRecipes.forEach(recipeID => {
            const recipe = recipes.find(r => r.ID === recipeID);
            if (recipe && recipe.Ostettava) {
                list.push({ title: recipe.Nimi, items: recipe.Ostettava.split(',').map(item => item.trim()) });
            }
        });
        setShoppingList(list);
        setShowShoppingList(true);
    };

    const isMobileDevice = () => {
        return /Mobi|Android/i.test(navigator.userAgent);
    };

    const shareOrCopyShoppingList = () => {
        const textToShare = shoppingList
            .map(group => `${group.title}\n${group.items.join('\n')}`)
            .join('\n\n');
        
        if (isMobileDevice() && navigator.share) {
            // If on mobile and Web Share API is available, use it
            navigator.share({
                title: 'Ostoslista',
                text: textToShare
            })
            .then(() => console.log('Shopping list shared successfully!'))
            .catch((error) => console.error('Error sharing:', error));
        } else {
            // Fallback to copy to clipboard for desktop
            navigator.clipboard.writeText(textToShare)
                .then(() => alert('Ostoslista copied to clipboard!'))
                .catch(err => alert('Failed to copy text: ' + err));
        }
    };

    const closeModal = () => {
        setShowShoppingList(false);
    };

    const isRecipeFavorite = (id) => favoriteRecipes.includes(id);
    const isButtonActive = favoriteRecipes.length > 0;
    const buttonIcon = isButtonActive ? 'assets/activeFav.svg' : 'assets/defaultFav.svg';

    return (
        <div id="ContentWrapper">
            <div id="RecipeListContainer">
                <div className="ListtHeader">
                    <h2>Perheen safkat</h2>
                </div>

                <div className={`ostoslista-button-container ${isButtonActive ? 'active' : 'empty'}`}>
                    <button onClick={generateShoppingList} className="bigButton">
                        <img src={buttonIcon} alt="Ostoslista Icon" className="ostoslista-icon" />
                    </button>
                </div>

                {showShoppingList && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <button onClick={closeModal} className="close-modal">✕</button>
                            <h3>Ostoslista</h3>
                            <button onClick={clearFavorites} className="bigButton clear-favorites-button">
                                Empty Favorites
                            </button>
                            <div className="shopping-list-container">
                                {shoppingList.length === 0 ? (
                                    <p>No items in the shopping list.</p>
                                ) : (
                                    shoppingList.map((group, index) => (
                                        <div key={index} className="shopping-list-group">
                                            <h4>{group.title}</h4>
                                            <ul>
                                                {group.items.map((item, idx) => (
                                                    <li key={idx}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))
                                )}
                            </div>
                            <button onClick={shareOrCopyShoppingList} className="bigButton">
                                {isMobileDevice() ? 'Share List' : 'Copy List'}
                            </button>
                        </div>
                    </div>
                )}

                <ul>
                    {visibleRecipes.map((recipe) => (
                        <RecipeItem
                            key={recipe.ID}
                            recipe={recipe}
                            isFavorite={() => isRecipeFavorite(recipe.ID)}
                            toggleFavorite={toggleFavorite}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Reseptit;
